<template>
    <v-container fluid>
      <v-row>
        <v-col cols="11" md="11">
          <!-- Utilizza il componente v-btn-group -->
          <v-btn-group  v-if="!computedIsProducers" class="button-with-border">
            <v-btn
              v-for="section in sections.slice(0, 5)"
              :key="section.id"
              @click="selectSection(section.id)"
              :class="{ 'selected-button': selectedSection === section.id }"
              outlined
              :color="section.color"    
              class="button-height"          
            >
            <div class="button-content">
                <div class="button-text">{{ section.text }}</div>
                <img :src="section.icon" alt="icon" class="icon-img" />                
              </div>
            </v-btn>
          </v-btn-group>   
          <v-btn-group  v-else class="button-with-border2">
            <v-btn
              v-for="section in sections"
              :key="section.id"
              @click="selectSection(section.id)"
              :class="{ 'selected-button': selectedSection === section.id }"
              outlined
              :color="section.color"    
              class="button-height"          
            >
            <div class="button-content" >
                <div class="button-text">{{ section.text }}</div>
                <img :src="section.icon" alt="icon" class="icon-img" />                
              </div>
            </v-btn>
          </v-btn-group>                     
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="9">
          <div v-if="(selectedSection==2)">
            <v-card style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;">  
              <v-card>                                        
              <v-card-title class="headline d-flex justify-space-between">
                Tools Assistant
              </v-card-title>
              <v-card-text style="max-height: 500px;">
                <div>
                  <v-form>
                  
                    <v-select
                      v-model="selectedManual"
                      :items="files.map(file => file.originalname)"
                      label="Select a Manual"
                      outlined
                    ></v-select>
                  
                    <v-text-field 
                      v-model="userMessage" 
                      label="Message" 
                      placeholder="Ask information about E-Photo manuals..." 
                      required 
                      outlined
                    ></v-text-field>
                    <div class="d-flex align-items-center" style="width: 100%;">
                      <v-progress-linear   color="yellow" :indeterminate="!(totalProgressAI === 0 || totalProgressAI === 100)"  max="100" height="35" style="flex-grow: 1;border-radius: 5px;"></v-progress-linear>
                      <v-btn @click="sendHelp" class="button-background" v-ripple style="margin-left: 10px;">Send</v-btn>
                    </div>
                  </v-form>
                </div>
                <div class="d-flex justify-space-between align-items-start mt-4">
                  <!-- Messaggio di risposta -->
                  <div  style="flex: 1;position: relative;background-color:whitesmoke;padding: 10px;overflow: auto;border-radius: 5px; max-height: 200px;white-space: pre-wrap;">
                    {{ responseMessage }}                                
                  </div> 
                  <!-- Robot container -->
                  <div class="robot-container ml-4" style="width: 100px;">
                    <img
                      :src="isSpeaking ? require('@/assets/Assistant_talk.jpg') : require('@/assets/Assistant.jpg')"
                      alt="Talking Robot"
                      class="robot-face"
                      width="100"
                    />
                    <!-- Bocca del robottino animata -->
                    <div
                      class="robot-mouth"
                      v-if="isSpeaking"
                      :class="{ 'speaking': responseMessage !== '' }"
                    ></div>
                  </div>
                </div>
              </v-card-text>   
              </v-card>     
            </v-card>
          </div>
          <div v-else>
            <v-card v-if="(selectedSection!=5 || isAdmin==1)" style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;">                      
              <v-card-title @click="toggleCollapse" class="d-flex justify-space-between align-center" style="cursor: pointer;">
                <span><v-icon class="mr-2">mdi-plus</v-icon>Post-it</span>
                  <v-icon>{{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                </v-card-title>
                <v-expand-transition>
                  <div v-show="!isCollapsed">
                  <transition name="fade">
                    <v-text-field style="border-radius: 20px;" variant="solo-filled" v-model="newTitle" label="Title"  maxlength="30" prepend-inner-icon="mdi-pencil"></v-text-field>
                  </transition>
                  <transition name="fade">
                    <QuillEditor class="white-background mt-1 mb-1" v-model="newContent" ></QuillEditor>
                  </transition>
                  <div class="d-flex flex-md-row">
                    <v-btn
                      @click="addPostIt"
                      :color="sections[selectedSection-1].color"
                      class="add-post-btn button-background mr-4 mt-4"
                      v-ripple>
                      Add Post-It
                    </v-btn>
                    <v-checkbox v-if="(isAdmin==1)" v-model="sendEmail" label="Send Email to all..." class="chkEmail"></v-checkbox>                    
                  </div>                  
                </div> 
              </v-expand-transition>                
            </v-card>
              
            <v-card style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;height: 95px;">                    
              <v-text-field
                v-model="filter"
                label="Filter Posts"
                variant="solo-filled"              
                prepend-inner-icon="mdi-filter">
              </v-text-field>
            </v-card>

            <div class="board animated-bg" :class="{'animated-bg': true}" :style="backgroundImageStyle">  
              <PostIt
                v-for="(post) in filteredPosts"
                :key="post.id"
                :title="post.title"
                :content="post.content"
                :id="post.id"
                :username="post.username"
                :currentUsername="username"
                :color="sections[selectedSection-1].color"
                :isadmin="isAdmin"
                @remove="removePost">
              </PostIt>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <v-card style="background-color: #9897A7;padding: 5px;margin-bottom: 20px;border-radius: 20px;">                            
          <FileUploader
              :addEnable="computedAddEnable" 
              :section="selectedSection"
              :currentUsername="username"
              :color="sections[selectedSection-1].color"
              :isadmin="isAdmin">
            </FileUploader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    
    
</template>
  
<script>
  import axios from 'axios';
  import PostIt from './PostIt.vue';
  import FileUploader from './FileUploader.vue';
  import QuillEditor from './QuillEditor.vue';
  import backCard_Blue from '@/assets/Iridescent_Light_Spectrum.jpg';
  import backCard_Green from '@/assets/Iridescent_Light_Spectrum.jpg';
  import backCard_Orange from '@/assets/Iridescent_Light_Spectrum.jpg';
  import backCard_Purple from '@/assets/Iridescent_Light_Spectrum.jpg';
  import backCard_Teal from '@/assets/Iridescent_Light_Spectrum.jpg';
  import iconPath1 from '@/assets/icons-02.png';
  import iconPath2 from '@/assets/icons-03.png';
  import iconPath3 from '@/assets/icons-04.png';
  import iconPath4 from '@/assets/icons-05.png';
  import iconPath5 from '@/assets/icons-06.png';
  import iconPath6 from '@/assets/icons-07.png';

  export default {
    name: 'BoardIt',
    components: { PostIt, FileUploader ,QuillEditor},
    data() {
      return {
        isAdmin: 0,
        newTitle: '',
        newContent: '',
        filter: '',
        posts: [],
        selectedSection: 1, // Sezione inizialmente selezionata
        username: localStorage.getItem('user'), // Ottieni il nome utente dal localStorage
        isProducer: false,
        sections: [
          { id: 1, text: 'E-People', icon: iconPath1, color: 'white', imageBack: backCard_Blue },
          { id: 2, text: 'Tools', icon: iconPath2, color: 'white', imageBack: backCard_Green },
          { id: 3, text: 'Job Alert', icon: iconPath3, color: 'white', imageBack: backCard_Orange },
          { id: 4, text: 'News', icon: iconPath4, color: 'white', imageBack: backCard_Purple },
          { id: 5, text: 'Conventions', icon: iconPath5, color: 'white', imageBack: backCard_Teal },
          { id: 6, text: 'Talent', icon: iconPath6, color: 'white', imageBack: backCard_Teal },          
        ],
        selectedManual: null,
        files: [],
        userMessage: '',
        responseMessage: '',
        totalProgressAI: 0,
        tokenAI: '',
        isSpeaking: false, // Stato per sapere se il robottino sta "parlando"

        isCollapsed: true,
        sendEmail: false,
      };
    },
    computed: {      
      computedAddEnable() {
        if(this.isAdmin == 0)
          return ((this.selectedSection == 5) || (this.selectedSection == 2)|| (this.selectedSection == 6)) ? 1 : 0;
        else
          return 0;
      },
      backgroundImageStyle() {
        const selected = this.sections.find(section => section.id === this.selectedSection);
        return selected ? { backgroundImage: `url(${selected.imageBack})` } : {};
      },    
      filteredPosts() {
        return this.posts
          .filter(post => post.section === this.selectedSection) // Filtra per sezione selezionata
          .filter(post =>
            post.title.toLowerCase().includes(this.filter.toLowerCase()) ||
            post.content.toLowerCase().includes(this.filter.toLowerCase())
          )
          .sort((a, b) => b.timestamp - a.timestamp);
      },
      computedIsProducers(){
        return (localStorage.getItem('isProducer') == 'false') ? false:true;
      }
    },
    methods: {
      toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
      },
      async sendHelp(){
        this.tokenAI = process.env.VUE_APP_AI;
        const serverAI = process.env.VUE_APP_SERVER_AI;
        
        console.log('sendHelp: ',serverAI);  
        
        if (!this.userMessage) {
          this.responseMessage = 'Please insert a message.';
          return;
        }
        if (!this.selectedManual) {
          this.responseMessage = 'Please insert a manual.';
          return;
        }
        const selManual = this.files.find(file => file.originalname === this.selectedManual);
        const manualUrl = `${process.env.VUE_APP_SERVER3}/uploads/${selManual.filename}`;
  
        console.log('selManual: ', manualUrl);  
        
        /*
        if (selectedManual) {
          const url = `${process.env.VUE_APP_SERVER3}/uploads/${selectedManual.filename}`;
          window.open(url, '_blank');
        }
        */
        try {
          // Ottieni il testo del PDF usando il nuovo endpoint backend
        const fileResponse = await fetch(`${process.env.VUE_APP_SERVER4}/extract-pdf-text?filename=${selManual.filename}`);
        if (!fileResponse.ok) {
          throw new Error('Could not fetch the manual content.');
        }

        const fileData = await fileResponse.json();
        const fileContent = fileData.text;
        //console.log('File content fetched:', fileContent);

          
          //console.log('file:',fileContent);
          this.totalProgressAI = 25;
          //asst_YdLTG6OEl6Y4JCvxHKb6WemQ
        
          
          const response = await fetch(serverAI + '/Auth/GetGPTAPI', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.tokenAI}`,
            },
            body: JSON.stringify({
              token: this.tokenAI,
              prompt: JSON.stringify({
                model: 'gpt-4o-mini',
                messages: [
                  { role: 'system', content: 'Sei un assistente tecnico per fornire esclusivamente supporto in base alla documentazione tecnica disponibile al seguente link: ' + fileContent },
                  { role: 'assistant', content: 'Il tuo nome è Sario' },
                  { role: 'user', content: this.userMessage }
                ]
              })
            })
          });
          this.totalProgressAI = 75;
          const data = await response.json();
          //console.log('ret data:', data);
          if (data.return) {
            this.responseMessage = data.return;
            this.startSpeakingAnimation(data.return.length); // Avvia l'animazione parlante in base alla lunghezza della risposta
          } else {
            this.responseMessage = 'Non sono riuscito a ottenere una risposta. Per favore riprova.';
          }        
        } catch (error) {
          this.responseMessage = 'Si è verificato un errore. Per favore riprova più tardi.';
        } finally {
          this.totalProgressAI = 100;
        }
      },
      startSpeakingAnimation(responseLength) {
        this.isSpeaking = true;
        const duration = Math.min(Math.max(responseLength * 50, 2000), 10000); // Durata proporzionale alla lunghezza, minimo 2s e massimo 10s
        
        setTimeout(() => {
          this.isSpeaking = false;
        }, duration);
      },
      async loadFiles() {
        const response = await axios.get(process.env.VUE_APP_SERVER3 + '/files', {
          params: { section: this.selectedSection },
        });
        console.log('board files:' ,response.data)
        // Filtra solo i file PDF
    this.files = response.data.filter(file => file.filename.toLowerCase().endsWith('.pdf'));
      },
      selectSection(section) {        
        this.selectedSection = section;
        
        this.loadPosts();

        this.loadFiles();
      },
      async addPostIt() {
        if (this.newTitle && this.newContent) {
          const newPost = {
            title: this.newTitle,
            content: this.newContent,
            timestamp: Date.now(),
            section: this.selectedSection, // Aggiungi la sezione al nuovo post
            username: this.username, // Aggiungi il nome utente al nuovo post
          };
          //console.log('Content: ',this.newContent)
          try{
            if(this.sendEmail){
              try {
                const response = await axios.post(process.env.VUE_APP_SERVER2 + '/sendFeedbackEmail', {
                  to: 'support@e-photo.it', // Destinatario dell'email
                  subject: `New Post-It Created: ${this.newTitle}`,
                  text: `A new Post-It has been created with the following content:\n${this.newContent}`,
                  comment: this.username,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });

                if (response.status === 200) {
                  console.log('Email sent successfully');
                  this.sendEmail = false;
                } else {
                  console.log('Error sending email');
                }
              } catch (error) {
                console.error('Error during email sending:', error);
              }
            }
            //const response = await axios.post('http://localhost:5000/posts', newPost);
            const token = localStorage.getItem('token');
            const response = await axios.post(process.env.VUE_APP_SERVER3 +'/posts', newPost, {
              headers: { Authorization: token },
            });
            this.posts.push(response.data);
            this.newTitle = '';
            this.newContent = '';
          } catch (error) {
            console.error(error)
          }
        }
      },
      async removePost(id) {
        if (confirm('Are you sure you want to delete this post?')) {
          const token = localStorage.getItem('token');
          //await axios.delete(`http://localhost:5000/posts/${id}`);
          await axios.delete(process.env.VUE_APP_SERVER3 + `/posts/${id}`, {
            headers: { Authorization: token },
          });
          
          this.posts = this.posts.filter(post => post.id !== id);
        }
      },
      async loadPosts() {        
        const response = await axios.get(process.env.VUE_APP_SERVER3 + '/posts', {
          params: { section: this.selectedSection },
        });
        this.posts = response.data;
      },
    },
    mounted() {      
      this.isAdmin = localStorage.getItem('isAdmin') || 0;
      this.isProducer = (localStorage.getItem('isProducer') == 'false') ? false:true;
      console.log('isProducer Board:', this.isProducer);
      console.log('isAdmin Board:', this.isAdmin);

      console.log(process.env.VUE_APP_SERVER3);
      console.log(this.username);
      
      this.loadPosts();
      
      this.loadFiles();
    },
  };
  </script>
  
<style scoped>
  .board {
    padding: 20px;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;    
    background-size: cover;
    background-repeat: repeat;
    background-position: center;      
  }
  .animated-bg {
    animation: slideBackground 8s linear infinite;
    
  }

  /* Keyframe for the sliding background */
  @keyframes slideBackground {
    0% { background-position: 0% 100%; }
    50% { background-position: 100% 0%; }
    100% { background-position: 0% 100%; }
  }
  /* Keyframe for the sliding background */
  @keyframes slideBackgroundDiagonal {
      0% { background-position: 0% 0%; }
      50% { background-position: 50% 50%; }
      100% { background-position: 100% 100%; }
  }

  .white-background {
    background-color: white !important;
  }
  .selected-button {
    background-color: #d3d3d3 !important; /* Colore di sfondo per il pulsante selezionato */
  }
  /* Animazioni */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.list-move {
  transition: transform 0.5s;
}

/* Bottoni con animazioni */
.add-post-btn {
  animation: bounce 1s infinite;
  font-size: large;
  color: white !important;
  border-radius: 20px;
  height: 50px;
  width: 300px;  
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Aggiungi un'animazione di scaling ai bottoni */
.v-btn {
  transition: transform 0.2s;
}
.v-btn:hover {
  transform: scale(1.05);
}
.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 100px;
}
.button-with-border {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid black !important; /* Bordo nero */
  border-radius: 20px; /* Arrotondamento degli angoli */
  min-height: 90px; 
  width: 681px !important;
}
.button-with-border2 {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid black !important; /* Bordo nero */
  border-radius: 20px; /* Arrotondamento degli angoli */
  min-height: 90px;   
  width: 813px !important;
}

/* Media queries per la visualizzazione mobile */
@media (max-width: 1200px) {
  .button-with-border {
    min-height: 120px;    
  }
  .button-with-border2 {
    min-height: 120px;    
  }
  .button-content {
    min-width: 10px !important; /* Riduci la larghezza dei bottoni */
    padding: 0 !important; /* Rimuovi il padding */
  }

  .button-text {
    display: none !important; /* Nascondi il testo */
  }

  .icon-img {
    margin-top: 0 !important; /* Rimuovi lo spazio tra l'icona e il testo */
    width: 24px;
    height: 24px;
  }
}

.button-background {
  background-image: url('@/assets/Iridescent_Light_Spectrum.jpg'); /* Percorso dell'immagine */
  background-size: cover; /* Adatta l'immagine alla dimensione del bottone */
  background-position: center; /* Centra l'immagine nel bottone */
  color: white; /* Colore del testo per contrastare con l'immagine di sfondo */
}
.icon-img {
  width: 44px;
  height: 44px;
  margin-bottom: 8px; /* Aggiungi spazio tra l'icona e il testo */
}
.selected-button {
  background-color: #9897A7 !important; /* Colore di sfondo per il pulsante selezionato */
}

.button-text {
  white-space: nowrap;
  font-weight: bold;
}
.button-height {
  height: 100%; /* Imposta l'altezza del bottone per corrispondere alla toolbar */
}
.chkEmail{
  font-weight: bold;
  color: white;
  margin-top: 10px;
}
@media (max-width: 600px) {
  .chkEmail{
    margin-top: 0px;
  }
  .flex-md-row {
    flex-direction: column !important;        
  }
  .align-md-center {
    align-items: flex-start !important;       
  }
}
</style>
  